import { render, staticRenderFns } from "./CadRedesSociais.vue?vue&type=template&id=9d8695e4&"
import script from "./CadRedesSociais.vue?vue&type=script&lang=js&"
export * from "./CadRedesSociais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports